import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

// Feature-related actions
export const featuresByRoleLibAsync = createAsyncThunk(
  'feature/fetch-features-by-role',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/fetch-features-by-roles', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)

export const allFeaturesLibAsync = createAsyncThunk(
  'feature/fetch-all-features',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', 'v2/rbac-config/fetch-all-features', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)

export const assignFeatureToRoleLibAsync = createAsyncThunk(
  'feature/assign-feature-to-role',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/assign-feature-to-role', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)

export const deleteFeatureLibAsync = createAsyncThunk(
  'feature/remove-feature-from-role',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/remove-feature-from-role', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)
